import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";

const SelectSeat = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="walletpage">
        <div className="headersection">
          <div onClick={() => window.history.back()}>
            <img src="/back-icon.svg" />
          </div>
          <div>Movie Ticket</div>
          <div></div>
        </div>
        <div className="contentSection">
          <img src="/seats.png" />

          <div>
            <button
              className="blueButton mt100"
              onClick={() => navigate("/pay-options")}
            >
              Pay 1381.56 AED
            </button>
          </div>
        </div>
      </div>
      <Navbar />
    </>
  );
};

export default SelectSeat;
